import React, { useEffect, useState, useCallback } from "react";
import { useParams } from 'react-router-dom';
import { PaymentElement, useStripe, useElements } from "@stripe/react-stripe-js";
import configVars from "../../config";

const CheckoutForm = (props) => {
  const stripe = useStripe();
  const elements = useElements();

  const { plan, type } = useParams();
  const [message, setMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

	const createMembership = useCallback(async ( secret, method, intent ) => {
		
		const response = await fetch(
			`${configVars.apiUrl}sustainchange/v1/savestripeuser/?client_secret=${encodeURIComponent(secret)}&payment_method=${encodeURIComponent(method)}&intent=${encodeURIComponent(intent)}`,
			{
				method: "GET",
				headers: {
					Authorization: `Basic ${configVars.auth}`,
				},
			}
		);

		const userResponse = await response.json();

		if ( userResponse ) {
			//console.log( userResponse );

			if ( userResponse.success === false ) {
				setIsSuccess( false );
				setMessage( userResponse.message );
			}
		}

	}, [])

	useEffect(() => {
		if (!stripe) {
			return;
		}

		const clientSecret = new URLSearchParams(window.location.search).get(
			"payment_intent_client_secret"
		);

		if (!clientSecret) {

			const setupClientSecret = new URLSearchParams(window.location.search).get(
				"setup_intent_client_secret"
			);

			if ( setupClientSecret ) {

				const redirectStatus = new URLSearchParams(window.location.search).get(
					"redirect_status"
				);

				if ( redirectStatus ) {

					stripe.retrieveSetupIntent(setupClientSecret).then(({setupIntent}) => {
			
						switch (setupIntent.status) {
						case "succeeded":
							setMessage("Beställningen lyckades! Nu kommer du få mail med dina inloggningsuppgifter och information om hur du kommer igång med tjänsten.Välkommen till oss! ");
							createMembership(setupIntent.client_secret, setupIntent.payment_method, setupIntent.id);
							setIsSuccess(true);
							break;
						case "processing":
							setMessage("Vi behandlar din betalning. Vi uppdaterar dig när betalningen är klar.");
							createMembership(setupIntent.client_secret, setupIntent.payment_method, setupIntent.id);
							setIsSuccess( true );
							break;
						case "requires_payment_method":
							setMessage("Din betalning misslyckades, vänligen försök igen.");
							break;
						default:
							setMessage("Something went wrong.");
							break;
						}
					});

				}

				return;

			}

			return;
		} else {

			stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {

				switch (paymentIntent.status) {
				case "succeeded":
					setMessage("Beställningen lyckades! Nu kommer du få mail med dina inloggningsuppgifter och information om hur du kommer igång med tjänsten.Välkommen till oss! ");
					createMembership(paymentIntent.client_secret, paymentIntent.payment_method, paymentIntent.id);
					setIsSuccess(true);
					//console.log(paymentIntent);
					break;
				case "processing":
					setMessage("Vi behandlar din betalning. Vi uppdaterar dig när betalningen är klar.");
					createMembership(paymentIntent.client_secret, paymentIntent.payment_method, paymentIntent.id);
					setIsSuccess( true );
					break;
				case "requires_payment_method":
					setMessage("Din betalning misslyckades, vänligen försök igen.");
					break;
				default:
					setMessage("Something went wrong.");
					break;
				}
			});

		}

	}, [stripe, createMembership]);

	const handleSubmit = async (e) => {
		e.preventDefault();

		if (!stripe || !elements) {
			// Stripe.js has not yet loaded.
			// Make sure to disable form submission until Stripe.js has loaded.
			return;
		}

		setIsLoading(true);

		if ( props?.isTrial === true ) {

			const {error} = await stripe.confirmSetup({
				//`Elements` instance that was used to create the Payment Element
				elements,
					confirmParams: {
						return_url: `${window.location.origin}/plans/${plan}/${type}/complete`,
					}
			});
	
			if (error) {
				setMessage(error.message);
			} else {
				// Your customer will be redirected to your `return_url`. For some payment
				// methods like iDEAL, your customer will be redirected to an intermediate
				// site first to authorize the payment, then redirected to the `return_url`.
			}

		} else {

			const { error } = await stripe.confirmPayment({
				elements,
				confirmParams: {
					// Make sure to change this to your payment completion page
					return_url: `${window.location.origin}/plans/${plan}/${type}/complete`,
				},
			});
	
			// This point will only be reached if there is an immediate error when
			// confirming the payment. Otherwise, your customer will be redirected to
			// your `return_url`. For some payment methods like iDEAL, your customer will
			// be redirected to an intermediate site first to authorize the payment, then
			// redirected to the `return_url`.
			if (error.type === "card_error" || error.type === "validation_error") {
				setMessage(error.message);
			} else {
				setMessage("An unexpected error occured.");
				console.log( error );
			}

		}

		setIsLoading(false);
	};

	

	return (
		<div className="checkout-form-wrap">
			{/* Show any error or success messages */}
			{message &&
				<div className={`alert alert-${isSuccess === true ? 'success' : 'danger'}`} id="payment-message" role="alert">{message}</div>
			}

			{!props.pstatus &&
				<form id="payment-form" onSubmit={handleSubmit}>

					<PaymentElement id="payment-element" />

					<button disabled={isLoading || !stripe || !elements} id="submit" className="btn btn-secondary mt-3">
						<span id="button-text">
							{(isLoading || !stripe || !elements) &&
								<div className="d-flex justify-content-center mt-5">
									<div className="spinner-border text-white spinner-border-sm" role="status">
										<span className="visually-hidden">Loading...</span>
									</div>
								</div>
							}

							{( !isLoading && stripe && elements ) &&
								<span>
									<span className="pe-2"><i className="fa fa-money" aria-hidden="true"></i></span>
									Starta prenumeration
								</span>
							}
						</span>
					</button>

				</form>
			}
		
		</div>
	);
}

export default CheckoutForm;